export default Object.freeze({
  NONE: 'none',
  PUBLIC: 'public',
  MODERATED: 'moderated'
})
